import { Typography, cn } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import ReactHtmlParser from 'react-html-parser';

interface Props {
  content: string;
  className?: string;
}

function ChatMessageBody({ content, className }: Props) {
  return (
    <Typography
      variant="bodyMedium"
      as="div"
      className={cn(
        '[&_p]:mb-6 [&_p]:last:mb-0',
        '[&_ul]:mb-4 [&_ul]:list-disc [&_ul]:pl-6',
        '[&_ol]:mb-4 [&_ol]:list-decimal [&_ol]:pl-6',
        '[&_li]:mb-2 [&_li]:last:mb-0',
        '[&_strong]:font-semibold',
        '[&_em]:italic',
        className,
      )}
    >
      {ReactHtmlParser(content)}
    </Typography>
  );
}

export default observer(ChatMessageBody);
